export const SWAP = 1
export const PADDED = 2
export const MISMATCH = 3

const logAspect = (width, height) => (width > 0 && height > 0 ? Math.log(width / height) : null)

export function flatSlot(photos) {
  if (photos.preview) return "preview"
  if (photos.primary) return "primary"
  return null
}

export function aspectPromptCase({ photo, width, height, framed, tolerances }) {
  const photoAspect = logAspect(photo?.width, photo?.height)
  const statedAspect = logAspect(width, height)
  if (photoAspect === null || statedAspect === null) return null

  const off = Math.abs(photoAspect - statedAspect)
  const offPct = Math.round((Math.exp(off) - 1) * 1000) / 10
  const nearSquare = Math.abs(statedAspect) <= tolerances.fit

  if (!framed && !nearSquare && Math.abs(photoAspect + statedAspect) <= tolerances.swap) return { case: SWAP, offPct }
  if (!nearSquare && Math.abs(photoAspect) <= tolerances.square) return { case: PADDED, offPct }
  if (off > tolerances.fit) return { case: MISMATCH, offPct }
  return null
}
